import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import {
  TranslateLoader,
  TranslateModule,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { catchError, of, tap } from 'rxjs';
import { routes } from './app.routes';
import { UserService } from './core/services/user.service';
import { UserStateService } from './core/services/user.state.service';
import { credentialsInterceptor } from './shared/interceptors/credentials.interceptor';
import { refreshTokenInterceptor } from './shared/interceptors/refresh-token.interceptor';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withInterceptors([credentialsInterceptor, refreshTokenInterceptor]),
    ),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'it',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    provideAppInitializer(() => {
      const userService = inject(UserService);
      const userStateService = inject(UserStateService);

      return userService.me().pipe(
        tap((user) => userStateService.user.set(user as any)),
        catchError(() => of(null)),
      );
    }),
  ],
};
